import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { MoveableContent } from '@alfa-bank/site-moveable-content';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { Link } from '@alfa-bank/site-link';
import { mapSpacerVerticalToStyler } from '@alfa-bank/site-helpers-transform/strings/map-size-spacer-to-styler';
import { parseNewLines } from '@alfa-bank/site-helpers-common/src/react/parse-new-lines';
import { FontStyrene as FontStyreneText } from '@alfa-bank/site-font-styrene';

import { animation, card } from '../config';
import { NavContainer } from '../components/nav-container';
import { CardCarousel as Component } from '../layouts/default';
import styles from '../styles/desktop.css';
import type { IDesktopDeps, TCarouselDesktop } from '../models';
import { renderCards } from '../utils/render-cards';
import { calculateCardWidths } from '../utils/card-widths';

export const CardCarousel = createWidget<IDesktopDeps<TCarouselDesktop>, TCarouselDesktop>({
    config: { animation, card },
    styles,
    Layout,
    Link,
    Text,
    Grid,
    Button,
    MoveableContent,
    FontStyreneText,
    NavContainer,
    calculateCardWidths,
    renderCards,
    sendEvent,
    mapSpacerVerticalToStyler,
    parseNewLines,
})(Component);
